import { Icon } from '@wearehelpful/ui-kit';
import styled from 'styled-components';
import { ListStyles, ListItemStyles } from '@bootstrap/components';

export const Root = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Placeholder = styled('div')`
  display: flex;
  justify-content: center;
  max-width: 320px;
  margin: 0 auto;
  padding-top: ${({ theme }) => theme.spacing(6)};
`;

export const List = styled('ul')`
  ${ListStyles}
  display: flex;
  flex-direction: column;
  gap: 12px;
  list-style-type: none;
  padding-inline-start: 0;
`;

export const ListItem = styled('li')`
  ${ListItemStyles}
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const CheckmarkIcon = styled(Icon).attrs({
  name: 'check',
  size: 'md',
})`
  display: inline-flex;
  background-color: ${({ theme }) => theme.palette.periwinkle200};
  border-radius: 4px;
  padding: 2px;
`;
